import { CheckboxGroup } from '@/components/commons/forms/CheckboxGroup'
import { Text } from '@/components/commons/typography/Text'
import { NumberInput } from '@mantine/core'
import { getStatsTypeByContentType } from 'containers/highlights/misc/highlightContentType'
import { useHighlightEditorStore } from 'containers/highlights/store/highlightEditor'
import { numberStatInput } from 'containers/highlights/styles/highlight.css'
import {
  HighlightContentStats,
  HighlightContentStatsName,
} from 'containers/highlights/types/highlights'
import { useMemo } from 'react'

export const Hstats = () => {
  const { highlight, updateHighlight } = useHighlightEditorStore()
  const inputsRef = useMemo(() => new Map(), [])

  const statsByContent = useMemo(() => {
    return getStatsTypeByContentType(highlight?.contentType)
  }, [highlight?.contentType])

  const stats = useMemo(() => {
    return statsByContent.map((stat) => {
      const isStatConfigured = highlight?.stats?.find((s) => s.name === stat)
      if (isStatConfigured) return isStatConfigured
      return {
        name: stat,
        value: undefined,
        visible: false,
      }
    })
  }, [highlight?.stats, statsByContent])

  const statsOptions: HighlightContentStats[][] = useMemo(() => {
    const array = [...stats]
    const result = []
    while (array.length > 0) {
      result.push(array.splice(0, 2))
    }
    return result
  }, [stats])

  const getOptions = (name: HighlightContentStatsName) => {
    return [
      {
        label: '',
        value: name,
      },
    ]
  }

  const isOptionSelected = (
    visible: boolean,
    name: HighlightContentStatsName
  ) => {
    if (visible)
      return {
        label: '',
        value: name,
      }
    return undefined
  }
  const onValueChange = (name: HighlightContentStatsName, value: number) => {
    const newStats = [...stats]
      .map((stat) => {
        if (stat.name === name) {
          return {
            ...stat,
            visible: value !== undefined && value !== null,
            value,
          }
        }
        return stat
      })
      .filter((stat) => stat.visible)
    updateHighlight({ stats: newStats })
  }

  return (
    <div className="flex flex-column gap-8">
      <div className="flex flex-column gap-12">
        {statsOptions.map((stats, index) => (
          <div className="flex gap-20" key={'stats_group_' + index}>
            {stats.map((stat) => (
              <div
                key={'stat_' + stat.name}
                className="bg-white-primary rounded-12 flex justify-space-between flex-1 py-5 px-16 items-center"
              >
                <div>
                  <Text variation="xSmall">{stat.name}</Text>
                  <NumberInput
                    variant="unstyled"
                    size="md"
                    radius="md"
                    value={stat.value}
                    ref={(ref) => inputsRef.set(stat.name, ref)}
                    hideControls
                    thousandSeparator=","
                    decimalSeparator="."
                    className={numberStatInput}
                    onChange={(v) => onValueChange(stat.name, Number(v))}
                  />
                </div>
                <div>
                  <CheckboxGroup
                    optionSelected={isOptionSelected(
                      stat.value !== undefined && stat.value !== null,
                      stat.name
                    )}
                    onChange={() => null}
                    options={getOptions(stat.name)}
                  />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
